/* Homepage media controller: no cart, product-form, identity or analytics changes. */
(function () {
  'use strict';
  if (window.MarayaHome) { window.MarayaHome.mount(); return; }
  var states = new Map();
  var mobile = window.matchMedia('(max-width: 749px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var dialog = null;
  var dialogVideo = null;
  var dialogOpen = false;
  var returnFocus = null;
  var previousOverflow = '';
  var connection = navigator.connection;

  function fallback(state, status) {
    state.host.dataset.autoplayState = status;
    if (status !== 'playing') state.host.classList.remove('has-frame');
  }

  function allowed(state) {
    return !document.hidden && !dialogOpen && !reduced.matches && !(connection && connection.saveData) && (!state.hero || mobile.matches);
  }
  function load(state) {
    if (state.loaded || !allowed(state) || (!state.visible && !state.near)) return;
    if (state.hero && !state.posterReady) return;
    state.video.muted = true;
    state.video.defaultMuted = true;
    state.video.playsInline = true;
    // Reuse the responsive poster already selected by the browser; avoid a second, larger download.
    var posterImage = state.host.querySelector('img');
    var selectedPoster = posterImage && posterImage.currentSrc;
    if (selectedPoster || state.video.dataset.poster) state.video.poster = selectedPoster || state.video.dataset.poster;
    state.video.preload = state.hero ? 'auto' : 'metadata';
    state.video.src = state.video.dataset.src;
    state.loaded = true;
    state.video.load();
  }
  function sync(state) {
    if (!state.host.isConnected) return;
    if (!allowed(state) || !state.visible) {
      state.video.pause();
      if (reduced.matches || (connection && connection.saveData)) fallback(state, 'manual');
      return;
    }
    if (state.blocked) return;
    load(state);
    if (!state.loaded) return;
    if (!state.video.paused) return;
    if (state.playingRequest) { state.resumeAfterRequest = true; return; }
    state.playingRequest = true;
    var play;
    try { play = state.video.play(); } catch (e) { play = Promise.reject(e); }
    Promise.resolve(play).then(function () {
      if (!allowed(state) || !state.visible) state.video.pause();
    }).catch(function (error) {
      // Aborted playback on scrolling/resize is not an autoplay rejection.
      if (!error || error.name !== 'AbortError') {
        state.blocked = true;
        fallback(state, 'blocked');
      }
    }).finally(function () {
      state.playingRequest = false;
      if (state.resumeAfterRequest) { state.resumeAfterRequest = false; sync(state); }
    });
  }
  function syncAll() { states.forEach(sync); }
  var nearObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = states.get(entry.target);
      if (!state) return;
      state.near = entry.isIntersecting;
      if (state.near) load(state);
      sync(state);
    });
  }, { rootMargin: '240px 0px', threshold: 0.01 }) : null;
  var playObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = states.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting && entry.intersectionRatio >= (state.hero ? 0.1 : 0.35);
      sync(state);
    });
  }, { threshold: [0, 0.1, 0.35] }) : null;

  function closeDialog() {
    if (dialog && typeof dialog.close === 'function') dialog.close();
    else if (dialog) { dialog.removeAttribute('open'); finishDialog(); }
  }
  function finishDialog() {
    if (!dialogOpen) return;
    dialogOpen = false;
    if (dialogVideo) {
      dialogVideo.pause();
      dialogVideo.removeAttribute('src');
      dialogVideo.removeAttribute('poster');
      dialogVideo.load();
    }
    document.body.style.overflow = previousOverflow;
    if (returnFocus && returnFocus.isConnected) returnFocus.focus();
    syncAll();
  }
  function openVideo(button) {
    if (!dialog || !dialogVideo) return;
    returnFocus = button;
    previousOverflow = document.body.style.overflow;
    dialogOpen = true;
    syncAll();
    var poster = button.querySelector('img');
    if (poster) dialogVideo.poster = poster.currentSrc || poster.src;
    dialogVideo.src = button.dataset.videoSrc;
    dialogVideo.muted = false;
    dialogVideo.controls = true;
    document.body.style.overflow = 'hidden';
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    dialog.querySelector('[data-mr-dialog-close]').focus();
    var promise = dialogVideo.play();
    if (promise && promise.catch) promise.catch(function () { /* Native controls remain available. */ });
  }
  function initDialog() {
    dialog = document.querySelector('[data-mr-home-dialog]');
    if (!dialog || dialog.dataset.mrBound) return;
    dialog.dataset.mrBound = 'true';
    dialogVideo = dialog.querySelector('video');
    dialog.addEventListener('close', finishDialog);
    dialog.addEventListener('click', function (event) { if (event.target === dialog) closeDialog(); });
    dialog.querySelector('[data-mr-dialog-close]').addEventListener('click', closeDialog);
  }
  function initHeroTracks() {
    document.querySelectorAll('[data-mr-hero-track]').forEach(function (track) {
      if (track.dataset.mrHeroBound) return;
      track.dataset.mrHeroBound = 'true';
      var hero = track.closest('.mr-home-hero');
      var dots = hero ? Array.prototype.slice.call(hero.querySelectorAll('[data-mr-hero-dot]')) : [];
      if (!dots.length) return;
      var scheduled = false;
      function update() {
        scheduled = false;
        var index = Math.round(Math.abs(track.scrollLeft) / Math.max(track.clientWidth, 1));
        index = Math.max(0, Math.min(dots.length - 1, index));
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-current', dotIndex === index);
        });
      }
      track.addEventListener('scroll', function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(update);
      }, { passive: true });
      update();
    });
  }

  function mount() {
    initDialog();
    initHeroTracks();
    // Theme editor reloads can leave old nodes disconnected. Release those only.
    states.forEach(function (state, host) {
      if (host.isConnected) return;
      state.video.pause();
      if (nearObserver) nearObserver.unobserve(host);
      if (playObserver) playObserver.unobserve(host);
      states.delete(host);
    });
    document.querySelectorAll('[data-mr-home-video]').forEach(function (video) {
      var host = video.closest('[data-mr-hero], [data-mr-video-card]');
      if (!host || states.has(host)) return;
      var hero = host.hasAttribute('data-mr-hero');
      var state = { video: video, host: host, hero: hero, loaded: false, visible: false, near: false,
        blocked: false, playingRequest: false, posterReady: !hero };
      states.set(host, state);
      var poster = host.querySelector('img');
      if (hero && poster) {
        state.posterReady = poster.complete && poster.naturalWidth > 0;
        var posterSettled = function () { state.posterReady = true; sync(state); };
        poster.addEventListener('load', posterSettled, { once: true });
        poster.addEventListener('error', posterSettled, { once: true });
      } else state.posterReady = true;
      if (poster && !hero) {
        if (poster.complete && !poster.naturalWidth) host.classList.add('poster-unavailable');
        poster.addEventListener('error', function () {
          // Keep a meaningful label if even the supplied poster cannot load.
          host.classList.add('poster-unavailable');
        });
      }
      video.addEventListener('playing', function () {
        if (!allowed(state) || !state.visible) { video.pause(); return; }
        state.blocked = false;
        fallback(state, 'playing');
        host.classList.add('has-frame');
      });
      video.addEventListener('pause', function () { fallback(state, state.blocked ? 'blocked' : 'paused'); });
      video.addEventListener('error', function () {
        state.blocked = true;
        fallback(state, 'blocked');
      });
      // Eagerly start only the visible mobile hero, never hidden desktop media.
      if (hero && mobile.matches) {
        var rect = host.getBoundingClientRect();
        state.visible = rect.bottom > 0 && rect.top < window.innerHeight;
        state.near = state.visible;
        sync(state);
      }
      if (nearObserver) nearObserver.observe(host);
      if (playObserver) playObserver.observe(host);
      if (!playObserver) fallback(state, 'manual');
      if (reduced.matches || (connection && connection.saveData)) fallback(state, 'manual');
    });
    document.querySelectorAll('[data-mr-video-open]').forEach(function (button) {
      if (button.dataset.mrBound) return;
      button.dataset.mrBound = 'true';
      button.addEventListener('click', function () { openVideo(button); });
    });
    document.querySelectorAll('[data-mr-row-scroll]').forEach(function (button) {
      if (button.dataset.mrBound) return;
      button.dataset.mrBound = 'true';
      button.addEventListener('click', function () {
        var row = button.closest('[data-mr-media-group]').querySelector('.mr-home-media-row');
        row.scrollBy({ left: Number(button.dataset.mrRowScroll) * row.clientWidth * 0.8, behavior: reduced.matches ? 'auto' : 'smooth' });
      });
    });
  }
  function mediaChanged() {
    states.forEach(function (state) {
      if (state.hero && !mobile.matches && state.loaded) {
        state.video.pause();
        state.video.removeAttribute('src');
        state.video.preload = 'none';
        state.video.load();
        state.loaded = false;
        state.host.classList.remove('has-frame');
      }
      if (state.hero && mobile.matches) {
        var rect = state.host.getBoundingClientRect();
        state.visible = rect.bottom > 0 && rect.top < window.innerHeight;
      }
      sync(state);
    });
  }
  function motionChanged() {
    states.forEach(function (state) { state.blocked = false; });
    syncAll();
  }
  function retryVisible() {
    if (dialogOpen) return;
    states.forEach(function (state) {
      if (!state.visible || !allowed(state)) return;
      state.blocked = false;
      if (state.video.error) state.video.load();
      sync(state);
    });
  }
  if (mobile.addEventListener) {
    mobile.addEventListener('change', mediaChanged);
    reduced.addEventListener('change', motionChanged);
  } else {
    mobile.addListener(mediaChanged);
    reduced.addListener(motionChanged);
  }
  document.addEventListener('visibilitychange', syncAll);
  // Retry only on a real gesture, never a busy timer that fights Safari policy.
  document.addEventListener('click', retryVisible);
  document.addEventListener('touchend', retryVisible, { passive: true });
  window.addEventListener('pageshow', retryVisible);
  window.addEventListener('pagehide', function () { states.forEach(function (state) { state.video.pause(); }); });
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', function () { window.setTimeout(mount, 0); });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && dialogOpen) closeDialog(); });
  window.MarayaHome = { mount: mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
